import React, { useRef, useState } from 'react'
import { Modal, Offcanvas } from "react-bootstrap";
import CroppieModal from "../croppie-modal";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ErrorMessage from '../errors/errorMessage';
import { apiUrl } from '../../utils/url';
import { toast } from 'react-toastify';
import { hideLoader, showLoader } from '../loader';
import AddVariableInput from '../common/add-variable-input';

const EditLead = ({ show, setShow, callAudience }) => {
    const [formData, setFormData] = useState(show?.leadData || {});
    const [customVariables, setCustomVariables] = useState(show?.leadData?.data || []);
    let history = useHistory();
    const [error, setError] = useState([])
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const profilePicRef = useRef(null);
    const variables = useSelector(state => state?.variablesReducer);
    const predefinedVariables = new Set(['company_name', 'lead_first_name', 'email', 'ignore']);
    const fileupload = useRef(null);
    const removeModal = () => {
        setShow({show:false})
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleCustomVariableChange = (variableKey, value) => {
        setCustomVariables(prevVariables => {
          const existingVariable = prevVariables.find(v => v.key === variableKey);
          
          if (existingVariable) {
            return prevVariables.map(v => 
              v.key === variableKey ? { ...v, value } : v
            );
          }
          
          return [...prevVariables, { key: variableKey, value }];
        });
      };
    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();

        try {
            const formdata = new FormData();

            // Add basic fields
            formdata.append('subscriber_id', formData.id);
            formdata.append('name', formData.name);
            formdata.append('email', formData.email);
            formdata.append('company_name', formData.company_name);
            formdata.append('slug', slug);

            // Handle logo upload
            if (formData.logo && formData.logo !== show?.leadData?.logo) {
                // Convert base64 to blob
                const base64Response = await fetch(formData.logo);
                const blob = await base64Response.blob();
                formdata.append('logo', blob, 'image.png');
            }

            // Add custom variables
            formdata.append('data', JSON.stringify(customVariables));

            const response = await fetch(`${apiUrl}/community/subscribers/update`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: formdata
            });

            const result = await response.json();

            if (result?.status_code === 200) {
                callAudience()
                removeModal()
                toast.success(result.status_message);
            } else {
                toast.error(result.status_message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            hideLoader();
        }
    };
    const onfilechange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setFormData(prev => ({ ...prev, logo: e.target.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Modal id="editLeadModal" show={show?.show} onHide={removeModal} placement="end" className="right w-auto m-0" >
            <div class="modal-dialog modal-dialog-centered h-100 m-0" role="document">
                <div class="modal-content p-0 zaap-border-straight h-100">

                    <div class="modal-header">
                        <span class="modal-new-title">Edit Lead</span>


                        <button type="button" className="close" onClick={() => removeModal()}>
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 1L1 9M1 1L9 9" stroke="#5B5B5B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="modal-body pb-3 custom-scrollbar overflow-auto">
                        <ErrorMessage error={error} />
                        <form className='edit-lead-form'>
                            <div className='d-flex align-items-center gap-3 flex-wrap justify-content-between'>
                                <div class="profile-pic-box gap-2">
                                    {
                                        formData?.logo &&
                                        <div className="uploded-imge-area">
                                            <img src={formData?.logo} className='h-100 w-100 object-fit-contain' ref={profilePicRef} />
                                        </div>
                                    }
                                    <div>
                                        <span className="step-label">Workspace logo</span>
                                        <div onClick={() => fileupload.current.click()} className="register-btn mt-1 cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                            </svg>Upload New
                                        </div>
                                        <input id="file-upload" type="file" ref={fileupload} className="d-none" accept=".png,.jpg,.jpeg" name="logo" onChange={onfilechange} />
                                        <input type="hidden" name="image" value="" id="pp_image" />
                                    </div>
                                </div>
                                <AddVariableInput/>
                            </div>

                            <div>
                                <label className='productlabels' for="name">Lead Name</label>
                                <input className='zaapGlobal-input' type="text" id="name" name="name" placeholder="Enter name" value={formData?.name || ""} onChange={handleInputChange} />
                            </div>
                            <div>
                                <label className='productlabels' for="email">Lead Email</label>
                                <input className='zaapGlobal-input' type="text" id="email" name="email" placeholder="Enter email" value={formData?.email || ""} onChange={handleInputChange} />
                            </div>
                            <div>
                                <label className='productlabels' for="company_name">Company Name</label>
                                <input className='zaapGlobal-input' type="text" id="company_name" name="company_name" placeholder="Enter name" value={formData?.company_name || ""} onChange={handleInputChange} />
                            </div>
                            <span className='modal-new-title fs-16px'>Custom Variables</span>
                            {
                                variables?.length > 0 &&
                                variables
                                    ?.filter(label => !predefinedVariables?.has(label))
                                    .map((label, index) => {
                                        const matchedData = customVariables?.find(dataItem => dataItem?.key === label); // Ensure `variable` is properly matched
                                        return (
                                            <div key={index}>
                                                <label className='productlabels'>{label}</label>
                                                <input
                                                    type="text"
                                                    placeholder={label}
                                                    value={matchedData?.value || ""}
                                                    onChange={(e) => handleCustomVariableChange(label, e.target.value)}
                                                    className="zaapGlobal-input"
                                                />
                                            </div>
                                        );
                                    })
                            }

                        </form>
                    </div>
                    <div className='borderless modal-footer gap-1 align-items-center justify-content-between flex-nowrap'>
                        <button type="button" onClick={removeModal} class="fs-12 w-100 mt-0 integration-btns integration-btn-grey">
                            Cancel
                        </button>
                        <button type="button" onClick={handleSubmit} class="fs-12 w-100 shadow-none  project-blue-btn">
                            Save Lead
                        </button>
                    </div>
                </div>
                {/* <CroppieModal
                    show={showCroppieModal}
                    handleHide={handleHideModal}
                    croppieClose={croppieClose}
                    croppedImage={croppedImage}
                    modalWidth={500}
                    postWidth={'postWidth'}
                /> */}
            </div>
        </Modal>
    )
}

export default EditLead